import { useState, useEffect } from 'react';
import { TableActionsConfigs } from 'common/visualizations/views/agGridReact/TableActionsButton/types';

interface ExtraParams {
  showAllActions?: boolean;
  isBatchFetch?: boolean;
  primaryValues?: string;
}

interface FetchTableActionsParams {
  contextParams: TableActionsConfigs | object;
  extraParams?: ExtraParams;
}

export const fetchTableActionsData = async ({ contextParams, extraParams }: FetchTableActionsParams) => {
  const url = '/process_discovery/actions';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...contextParams, ...extraParams }),
  });
  if (!response.ok) {
    return { errorCode: response.status, message: 'Failed to fetch process discovery results' };
  }

  const data = await response.json();
  return data?.results;
};

export const useTableActionsResults = (
  contextParams: TableActionsConfigs | object,
  extraParams?: ExtraParams,
) => {
  const { mappedColumns } = contextParams as TableActionsConfigs;
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const fetchTableActionsResultsInternal = async () => {
    try {
      if (mappedColumns && mappedColumns.length > 0) {
        setLoading(true);

        const tableActionsData = await fetchTableActionsData({
          contextParams,
          extraParams,
        });

        setResults(tableActionsData || {});
      } else {
        setResults({});
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTableActionsResultsInternal();
  }, [mappedColumns]);

  return { tableActionsResults: results, loading, error };
};
